import { CombinedFeedbackDataArray } from '@mopla/data-models';
import { actionGenerator } from '@mopla/utils';

export enum PushActionTypes {
	InitPassengerPushes = '[Push] Init Passenger Pushes',
	AddPushToken = '[Push] Add Push Token',
	TripFeedbackManual = '[Push] Trip Feedback called manually',
}

export const initPassengerPushes =
	actionGenerator<PushActionTypes.InitPassengerPushes>(
		PushActionTypes.InitPassengerPushes
	);

interface Payload {
	token: string;
}
export const addPushToken = actionGenerator<
	PushActionTypes.AddPushToken,
	Payload
>(PushActionTypes.AddPushToken);

export const tripFeedbackManual = actionGenerator<
	PushActionTypes.TripFeedbackManual,
	CombinedFeedbackDataArray
>(PushActionTypes.TripFeedbackManual);

export type InitPassengerPushesAction = ReturnType<typeof initPassengerPushes>;
export type AddPushTokenAction = ReturnType<typeof addPushToken>;
